import { useExportFile } from 'components/ExportCenter/hooks/useExportCenter';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { useOrgConfigQAEnable } from 'hooks/business/useOrgConfig';
import { useCallback } from 'react';
import { RobotContribution, downloadRobotContribution } from 'services/api/dashboard';
import { DashboardFilterType } from 'views/Dashboard/ImplementData/components/Filter/useFilter';
import { ctx2FetchParam } from 'views/Dashboard/ImplementData/utils';

const useDownload = () => {
  const qaEnable = useOrgConfigQAEnable();
  const lang = useSystemLanguageValue();
  const { run, loading } = useExportFile();

  const download = useCallback(
    (
      type: RobotContribution,
      filter: DashboardFilterType,
      conversationType?: Dashboard.RobotReceptionParams['conversationType'],
    ) => {
      const qaIs = qaEnable;

      return run(() =>
        downloadRobotContribution({
          ...ctx2FetchParam(filter),
          robotContributionType: type,
          conversationType,
          lang,
          qaIs,
        }),
      );
    },
    [lang, qaEnable, run],
  );

  return {
    downloading: loading,
    download,
  };
};
export default useDownload;
